export default __webpack_public_path__ + "static/media/slide_1.a499aa59.jpg";